import { Button, Grid } from "@material-ui/core";
import { Auth } from "aws-amplify";
import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import "./genai.css";

export default function Bussiness() {
  const [genaiaccess, setgenaiaccess] = useState(false);

  useEffect(() => {
    const username = localStorage.getItem(
      "CognitoIdentityServiceProvider.29j70cln6jt05tfejrnii8d5d.LastAuthUser",
    );
    const userdata = localStorage.getItem(
      `CognitoIdentityServiceProvider.29j70cln6jt05tfejrnii8d5d.${username}.userData`,
    );
    const jsondata = JSON.parse(userdata);
    const emailObj = jsondata.UserAttributes.find(
      (item) => item.Name === "email",
    );
    const email = emailObj?.Value || "";

    setgenaiaccess(email.includes("genai2244"));
  }, []);

  async function signOut() {
    try {
      await Auth.signOut({ global: true });
      window.location.reload();
    } catch (error) {
      // console.log('error signing out: ', error);
    }
  }
  return (
    <div>
      <div>
        <img
          id="backgroundmainimageoverlay"
          src="/assets/images/background/g7.mp4"
          alt="background-img"
          style={{
            filter: "opacity(0.2)",
            position: "fixed",
            zIndex: "-3",
            width: "100vw",
            height: "110vh",
            marginTop: "-10vh",
            overflow: "hidden",
          }}
        />
        <img
          style={{ zIndex: "-4" }}
          id="backgroundmainimage"
          src="/assets/images/background/MainBackground.png"
          alt="main-background-img"
        />
      </div>
      <div className="container-fluid navcontent">
        <div className="row justify-content-between">
          <div className="col-auto align-self-end">
            <div>
              <Grid
                style={{ display: "flex", position: "relative", zIndex: "4" }}
              >
                <Link to="/departments">
                  <Button variant="contained" component="span" color="primary">
                    Back
                  </Button>
                </Link>
              </Grid>
            </div>
          </div>
          <div className="col-auto align-self-end basicheader">
            <h2 style={{ paddingTop: "10vh !important", fontWeight: "bold" }}>
              Generative AI for Business Manufacturing
            </h2>
          </div>
          <div className="col-auto align-self-end">
            {/* <Link to="/" style={{paddingRight:"2vw"}}>
                                <Button  variant="contained" color="primary" >Home</Button>
                            </Link> */}
            <Button
              style={{
                backgroundColor: "#ffa502",
                position: "relative",
                zIndex: "4",
              }}
              variant="contained"
              onClick={() => {
                signOut();
              }}
              color="primary"
              component="span"
            >
              Sign Out
            </Button>
          </div>
        </div>
      </div>

      {genaiaccess ? (
        <div>
          <div className="exp-container" style={{ width: "90vw" }}>
            <div className="exp" style={{ padding: "1rem 1rem" }}>
              <h2>Equipment Service Chatbot</h2>
              <img
                className="exp-img"
                src="/assets/images/chatbot2.png"
                alt="exp-img"
                loading="eager"
              />
              <Link to="/service-chatbot">
                <p>Open</p>
              </Link>
            </div>
            {/* <div className="exp">
              <h2>
                Edge Live Effort <br /> Estimation Tool
              </h2>
              <img className="exp-img" src="./assets/images/chatbot2.png" />
              <Link to="/edge-tool">
                <p>Open</p>
              </Link>
            </div> */}
            <div className="exp">
              <h2>IT-OT Assessment</h2>
              <img
                className="exp-img"
                src="/assets/images/resume.jpg"
                alt="exp-img"
                loading="eager"
              />
              <Link to="/it-ot">
                <p>Open</p>
              </Link>
            </div>
            <div className="exp">
              <h2>
                Manufacturing Document <br /> Comparison
              </h2>
              <img
                className="exp-img"
                src="/assets/images/email-cot1.jpg"
                alt="data anlytics"
                loading="eager"
              />
              <Link to="/manufacturing-doc-comparison">
                <p>Open</p>
              </Link>
            </div>
            {/* <div className="exp">
              <h2>Service Manual Chatbot</h2>
              <img
                className="exp-img"
                src="./assets/images/service-manual.jpg"
              />
              <Link to="/service-manual">
                <p>Open</p>
              </Link>
            </div> */}
          </div>
          <div className="exp-container" style={{ width: "90vw" }}>
            <div className="exp">
              <h2>Data Analytics</h2>
              <img
                className="exp-img"
                src="/assets/images/diversity.jpg"
                alt="data anlytics"
                loading="eager"
              />
              <Link to="/bussiness-data-analytics">
                <p>Open</p>
              </Link>
            </div>
            <div className="exp">
              <h2>Data Analytics Agentic</h2>
              <img
                className="exp-img"
                src="/assets/images/data-analytics-agentic.jpg"
                alt="data analytics img"
                loading="eager"
              />
              <Link to="/data-analytics-new">
                <p>Open</p>
              </Link>
            </div>
            <div className="exp">
              <h2>
                Prompt Engineering using <br /> manufacturing Document
              </h2>
              <img
                className="exp-img"
                src="/assets/images/critical-convo.jpg"
                alt="service-manual-img"
                loading="eager"
              />
              <Link to="/manufacturing-prompt-engineering">
                <p>Open</p>
              </Link>
            </div>
          </div>
        </div>
      ) : (
        <h2 style={{ color: "white", textAlign: "center" }}>
          You do not have an access to use this section.
        </h2>
      )}
    </div>
  );
}
